// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { PhoneMenu } from './phone-menu'

const COMPONENT_ID = 'phoneMenu'

interface Prop {
  phone: string
}

export const showPhoneMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: PhoneMenu },
}
